export default {
    template: /*html*/`
    <svg xmlns="http://www.w3.org/2000/svg" width="12.057" height="6.779" viewBox="0 0 12.057 6.779">
        <path id="Tracciato_134" data-name="Tracciato 134" d="M4373.763-49.39l4.968,4.968,4.968-4.968" transform="translate(-4372.703 50.451)" fill="none" stroke="#707070" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"/>
    </svg>
    `
}

